import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const OAuthService = {
  getAuthUrl: () => {
    return axios.get(`${API_BASE_URL}/oauth/url`);
  },

  completeAuth: (code: string) => {
    return axios.post(`${API_BASE_URL}/oauth/callback`, { code });
  },

  getStatus: () => {
    return axios.get(`${API_BASE_URL}/oauth/status`);
  }
};